export default __webpack_public_path__ + "static/media/test.7cfd8ea6.mov";